import { all } from "redux-saga/effects";
import { watchTemplateAsync } from "./templateSaga";
import { watchZoneAsync } from "./zoneSaga";
import { emsTemplateAsync } from "./emsSaga";
import { watchFileAsync } from "./fileUploadSaga";
import { watchDocumentAsync } from "./documentSaga";
import { watchTokenAsync } from "./authSaga";

export function* rootSaga() {
  yield all([
    watchTemplateAsync(),
    watchZoneAsync(),
    emsTemplateAsync(),
    watchFileAsync(),
    watchDocumentAsync(),
    watchTokenAsync(),
  ]);
}
